<!-- <a href="https://api.whatsapp.com/send?phone=+24177942629&text=Bonjour,%20je%20suis%20intéressé%20par%20les%20produits PUPS" class="float" target="_blank">
  <i class="fab fa-whatsapp my-float"></i>
</a>
<a href="tel:+24177942629" class="tel">
  <i class="fas fa-phone my-float"></i>
</a> -->
<go-top-button [animate]="true" [speed]="50" [acceleration]="2" [scrollDistance]="300" [classNames]="'scroll-top-btn'" [styles]="{
                    'color': 'var(--primary-blue)',
                    'border': '5px solid',
                    'line-height': '20px'
                 }">
  <i class= "fa fa-arrow-up" ></i>
</go-top-button>
<!--  <a href="" class="float" target="_blank">
	<i class="fab fa-whatsapp my-float"></i>
</a>
<a href="" class="tel">
	<i class="fas fa-phone my-float"></i>
</a> -->
